import type { JSX } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import { useEffectOnlyOnMount } from '../../common/hookUtils/customHooks';
import { getLanguageData, getLocale, type LanguageDataInterface } from '../../configuration';
import { createVirtPathEvent } from '../../configuration/setup/googleTagManager';
import { WidgetVisibilityTrackerContainer } from '../../configuration/setup/VisbilityTracker.container';
import type { State } from '../../reducers';
import type { NonFunctionProperties } from '../../utils/util';
import { WidgetLocalStorageUpdaterContainer } from './browsercommunication/WidgetLocalStorageUpdater.container';
import { MessageHandlerContainer, sendMessage } from './MessageHandler';
import { WidgetViewContainer } from './views/WidgetView.container';
import { WidgetDataFetcherContainer } from './WidgetDataFetcher.container';

interface WidgetProperties {
    languageData: LanguageDataInterface;
    userLocale: string;
}

const WidgetLayout = (props: WidgetProperties): JSX.Element => {
    const { userLocale, languageData } = props;

    useEffectOnlyOnMount(() => {
        sendMessage({ type: 'EVENT_WIDGET_LOADED' });
    });

    useEffectOnlyOnMount(() => {
        document.documentElement.classList.add('is-iframe-widget');
    });

    return (
        <div>
            <WidgetVisibilityTrackerContainer googleAnalyticsEvent={createVirtPathEvent('widget/')} />
            <IntlProvider
                key={`intl-provider-${userLocale}`}
                locale={userLocale}
                messages={languageData}
                defaultLocale={'en-GB'}
            >
                <WidgetDataFetcherContainer />
                <WidgetLocalStorageUpdaterContainer />
                <MessageHandlerContainer />
                <WidgetViewContainer />
            </IntlProvider>
        </div>
    );
};

const mapStateToProps = (state: State): NonFunctionProperties<WidgetProperties> => ({
    languageData: getLanguageData(state),
    userLocale: getLocale(state),
});

export const WidgetContainer = connect(mapStateToProps)(WidgetLayout);
